const PostAuditingToolReportActionTypes = {
	/** ***************** GET POST AUDITING TOOL REPORT START *********************** */
	GET_POST_AUDITING_TOOL_REPORT_LIST_START: 'GET_POST_AUDITING_TOOL_REPORT_LIST_START',
	GET_POST_AUDITING_TOOL_REPORT_LIST_SUCCESS: 'GET_POST_AUDITING_TOOL_REPORT_LIST_SUCCESS',
	GET_POST_AUDITING_TOOL_REPORT_LIST_FAILURE: 'GET_POST_AUDITING_TOOL_REPORT_LIST_FAILURE',
	GET_POST_AUDITING_TOOL_REPORT_LIST_RESPONSE_RESET:
		'GET_POST_AUDITING_TOOL_REPORT_LIST_RESPONSE_RESET',
	GET_POST_AUDITING_TOOL_REPORT_LIST_RESPONSE_CHANGED:
		'GET_POST_AUDITING_TOOL_REPORT_LIST_RESPONSE_CHANGED',

	/** ***************** GET POST AUDITING TOOL REPORT END *********************** */

	/** ***************** FETCH POST AUDITING TOOL REPORT EXCEL DETAILS START *********************** */
	GET_POST_AUDITING_TOOL_REPORT_EXCEL_START: 'GET_POST_AUDITING_TOOL_REPORT_EXCEL_START',
	GET_POST_AUDITING_TOOL_REPORT_EXCEL_SUCCESS: 'GET_POST_AUDITING_TOOL_REPORT_EXCEL_SUCCESS',
	GET_POST_AUDITING_TOOL_REPORT_EXCEL_FAILURE: 'GET_POST_AUDITING_TOOL_REPORT_EXCEL_FAILURE',
	GET_POST_AUDITING_TOOL_REPORT_EXCEL_RESPONSE_RESET:
		'GET_POST_AUDITING_TOOL_REPORT_EXCEL_RESPONSE_RESET',
	GET_POST_AUDITING_TOOL_REPORT_EXCEL_RESPONSE_CHANGED:
		'GET_POST_AUDITING_TOOL_REPORT_EXCEL_RESPONSE_CHANGED',
	/** ***************** FETCH POST AUDITING TOOL REPORT EXCEL DETAILS END *********************** */
};
export default PostAuditingToolReportActionTypes;
